import {
  Col,
  message,
  PageHeader,
  Row,
  Spin,
  Select,
  Space,
  Tabs,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  SelectItem,
  Form,
  FormItem,
  RangePickerItem,
  TableItem,
  dineroDisabledMask,
  ButtonItem,
  ErrorItem,
  SwitchItem,
} from "../../../../Components/Items";
import { FileExcelOutlined } from "@ant-design/icons";
import * as XLSXStyle from "xlsx-js-style";
import { ResponsiveLine } from "@nivo/line";
import moment from "moment";
import "moment/locale/es";
import {
  DIAS_SEMANA,
  leerDiaInicioSemanaGuardado,
  guardarDiaInicioSemana,
  leerSepararMaquinariaGuardado,
  guardarSepararMaquinaria,
  leerSepararMaterialesGuardado,
  guardarSepararMateriales,
} from "./diaInicioSemana.utils";

moment.locale("es");

const { Option } = Select;
const { TabPane } = Tabs;

class ReporteCobranzaProyectadoVsReal extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    objetoClientes: null,
    todasClientes: null,
    objetoProyectos: null,
    todasProyectos: null,
    dataReporte: null,
    semanas: [],
    grupos: [],
    filas: [],
    totalesGeneralesProyectadoPorSemana: {},
    totalesGeneralesRealPorSemana: {},
    totalProyectado: 0,
    totalReal: 0,
    maquinariaProyectadoGeneral: 0,
    maquinariaRealGeneral: 0,
    materialesProyectadoGeneral: 0,
    materialesRealGeneral: 0,
    meses: [],
    generalesPorMes: {},
    dataGrafico: [],
    empresa: null,
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await axios
      .post(
        "clientes/selectClientes",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasClientes: res.data,
            objetoClientes: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.stringBuscar}
              </Option>
            )),
          });
        }
      });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasProyectos: res.data,
            objetoProyectos: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre}
              </Option>
            )),
          });
        }
      });
    this.consultarReporte({
      periodo: [moment().subtract(1, "month"), moment()],
      clientes: 0,
      proyectos: 0,
      diaInicioSemana: leerDiaInicioSemanaGuardado(),
      separarMaquinaria: leerSepararMaquinariaGuardado(),
      separarMateriales: leerSepararMaterialesGuardado(),
    });
  }

  consultarReporte(values) {
    this.setState({ loading: true });
    const diaInicioSemana = values.diaInicioSemana ?? 0;
    const separarMaquinaria = values.separarMaquinaria !== false;
    const separarMateriales = values.separarMateriales !== false;
    guardarDiaInicioSemana(diaInicioSemana);
    guardarSepararMaquinaria(separarMaquinaria);
    guardarSepararMateriales(separarMateriales);
    axios
      .post(
        "reportesAdministrativos/reporteCobranzaProyectadoVsReal",
        {
          fechaInicial: values.periodo[0].startOf("day").toISOString(),
          fechaFinal: values.periodo[1].endOf("day").toISOString(),
          clientes: values.clientes || 0,
          proyectos: values.proyectos || 0,
          diaInicioSemana,
          separarMaquinaria,
          separarMateriales,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          const semanas = res.data.semanas || [];
          const grupos = res.data.grupos || [];
          const totalesGeneralesProyectadoPorSemana = res.data.totalesGeneralesProyectadoPorSemana || {};
          const totalesGeneralesRealPorSemana = res.data.totalesGeneralesRealPorSemana || {};
          const totalProyectado = res.data.totalProyectado || 0;
          const totalReal = res.data.totalReal || 0;
          const maquinariaProyectadoGeneral = res.data.maquinariaProyectadoGeneral || 0;
          const maquinariaRealGeneral = res.data.maquinariaRealGeneral || 0;
          const materialesProyectadoGeneral = res.data.materialesProyectadoGeneral || 0;
          const materialesRealGeneral = res.data.materialesRealGeneral || 0;
          const meses = res.data.meses || [];
          const generalesPorMes = {
            maquinariaProyectadoPorMes: res.data.maquinariaProyectadoGeneralPorMes || {},
            maquinariaRealPorMes: res.data.maquinariaRealGeneralPorMes || {},
            materialesProyectadoPorMes: res.data.materialesProyectadoGeneralPorMes || {},
            materialesRealPorMes: res.data.materialesRealGeneralPorMes || {},
          };

          this.construirFilas(
            grupos,
            totalesGeneralesProyectadoPorSemana,
            totalesGeneralesRealPorSemana,
            totalProyectado,
            totalReal,
            maquinariaProyectadoGeneral,
            maquinariaRealGeneral,
            materialesProyectadoGeneral,
            materialesRealGeneral,
            generalesPorMes
          );
          this.crearGrafico(semanas, totalesGeneralesProyectadoPorSemana, totalesGeneralesRealPorSemana);

          this.setState({
            dataReporte: res.data,
            semanas,
            grupos,
            totalesGeneralesProyectadoPorSemana,
            totalesGeneralesRealPorSemana,
            totalProyectado,
            totalReal,
            maquinariaProyectadoGeneral,
            maquinariaRealGeneral,
            materialesProyectadoGeneral,
            materialesRealGeneral,
            meses,
            generalesPorMes,
            empresa: res.data.empresa,
            loading: false,
          });
        } else {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        message.error("Ha sucedido un error y no se cargo bien el reporte");
        this.setState({ loading: false });
      });
  }

  construirFilas(
    grupos,
    totalesGeneralesProyectadoPorSemana,
    totalesGeneralesRealPorSemana,
    totalProyectado,
    totalReal,
    maquinariaProyectadoGeneral,
    maquinariaRealGeneral,
    materialesProyectadoGeneral,
    materialesRealGeneral,
    generalesPorMes
  ) {
    const filas = [];
    grupos.forEach((grupo) => {
      filas.push({
        isHeader: true,
        key: `header-${grupo.clienteId}-${grupo.proyectoId}`,
        etiqueta: `${grupo.cliente} - ${grupo.proyecto}`,
      });
      (grupo.facturas || []).forEach((factura, idx) => {
        filas.push({
          isDetail: true,
          key: `detalle-${grupo.clienteId}-${grupo.proyectoId}-${idx}`,
          folio: factura.folio,
          proyectado: factura.proyectado || {},
          real: factura.real || {},
          totalProyectado: factura.totalProyectado,
          totalReal: factura.totalReal,
          maquinariaProyectado: factura.maquinariaProyectado || 0,
          maquinariaReal: factura.maquinariaReal || 0,
          materialesProyectado: factura.materialesProyectado || 0,
          materialesReal: factura.materialesReal || 0,
          maquinariaProyectadoPorMes: factura.maquinariaProyectadoPorMes || {},
          maquinariaRealPorMes: factura.maquinariaRealPorMes || {},
          materialesProyectadoPorMes: factura.materialesProyectadoPorMes || {},
          materialesRealPorMes: factura.materialesRealPorMes || {},
        });
      });
    });
    if (grupos.length > 0) {
      filas.push({
        isGranTotal: true,
        key: "gran-total",
        proyectado: totalesGeneralesProyectadoPorSemana,
        real: totalesGeneralesRealPorSemana,
        totalProyectado,
        totalReal,
        maquinariaProyectado: maquinariaProyectadoGeneral,
        maquinariaReal: maquinariaRealGeneral,
        materialesProyectado: materialesProyectadoGeneral,
        materialesReal: materialesRealGeneral,
        ...generalesPorMes,
      });
    }
    this.setState({ filas });
  }

  crearGrafico(semanas, totalesGeneralesProyectadoPorSemana, totalesGeneralesRealPorSemana) {
    const dataProyectado = semanas.map((semana) => ({
      x: semana.label,
      y: totalesGeneralesProyectadoPorSemana[semana.key] || 0,
    }));
    const dataReal = semanas.map((semana) => ({
      x: semana.label,
      y: totalesGeneralesRealPorSemana[semana.key] || 0,
    }));
    this.setState({
      dataGrafico: [
        { id: "Proyectado", color: "hsl(210, 70%, 45%)", data: dataProyectado },
        { id: "Real", color: "hsl(140, 70%, 40%)", data: dataReal },
      ],
    });
  }

  descargarExcel() {
    const {
      semanas,
      grupos,
      totalesGeneralesProyectadoPorSemana,
      totalesGeneralesRealPorSemana,
      meses,
      generalesPorMes,
      empresa,
    } = this.state;
    const HEADER_COLOR = "D9D9D9";
    const TOTAL_COLOR = "E6FFFB";
    const MES_COLORS = ["BDD7EE", "8EA9DB"];
    // Formato Contabilidad: el signo de pesos queda pegado al borde izquierdo
    // de la celda y el numero al borde derecho, en vez de ir junto al numero.
    const FORMATO_CONTABILIDAD = '_-"$"* #,##0.00_-;-"$"* #,##0.00_-;_-"$"* "-"??_-;_-@_-';
    const border = {
      top: { style: "thin", color: { auto: 1 } },
      bottom: { style: "thin", color: { auto: 1 } },
      left: { style: "thin", color: { auto: 1 } },
      right: { style: "thin", color: { auto: 1 } },
    };
    const headerStyle = {
      font: { bold: true, sz: 11 },
      fill: { fgColor: { rgb: HEADER_COLOR } },
      alignment: { horizontal: "center", vertical: "center" },
      border,
    };
    const subHeaderStyle = {
      font: { bold: true, sz: 9 },
      fill: { fgColor: { rgb: HEADER_COLOR } },
      alignment: { horizontal: "center" },
      border,
    };
    const mesStyle = (color) => ({
      font: { bold: true, color: { rgb: "FFFFFF" }, sz: 11 },
      fill: { fgColor: { rgb: color } },
      alignment: { horizontal: "center", vertical: "center" },
      border,
    });
    const semanaStyle = {
      font: { bold: true, sz: 10 },
      fill: { fgColor: { rgb: "F2F2F2" } },
      alignment: { horizontal: "center" },
      border,
    };
    const rangoStyle = {
      font: { sz: 9, color: { rgb: "595959" } },
      fill: { fgColor: { rgb: "F2F2F2" } },
      alignment: { horizontal: "center" },
      border,
    };
    const blankStyle = { fill: { fgColor: { rgb: "F2F2F2" } }, border };
    const groupStyle = {
      font: { bold: true },
      fill: { fgColor: { rgb: TOTAL_COLOR } },
      border,
    };
    const totalStyle = {
      font: { bold: true, sz: 10 },
      fill: { fgColor: { rgb: TOTAL_COLOR } },
      alignment: { horizontal: "right" },
      numFmt: FORMATO_CONTABILIDAD,
      border,
    };
    const moneyStyle = {
      alignment: { horizontal: "right" },
      numFmt: FORMATO_CONTABILIDAD,
      border,
    };
    const plainBorder = { border };
    // xlsx-js-style no infiere el tipo de celda cuando ya se le pasa un
    // objeto { v, s } armado - sin "t" explicito, escribe el numero como
    // texto y Excel no puede aplicarle formato de moneda (queda con el
    // triangulo verde de "numero guardado como texto").
    const celdaMoneda = (valor, estilo) => (valor ? { v: valor, t: "n", s: estilo } : { v: "", s: estilo });
    // Maquinaria y materiales: por cada mes, una columna de proyectado y una de real.
    const celdasPorMes = (mapaProyectado, mapaReal, estilo) =>
      meses.flatMap((mes) => [
        celdaMoneda((mapaProyectado || {})[mes.key] || 0, estilo),
        celdaMoneda((mapaReal || {})[mes.key] || 0, estilo),
      ]);
    const blancos = (cantidad, estilo) => Array.from({ length: cantidad }, () => ({ v: "", s: estilo }));

    const colMaquinaria = 2 + semanas.length * 2;
    const colMateriales = colMaquinaria + meses.length * 2;
    const totalColumnas = colMateriales + meses.length * 2;
    const rows = [];
    const merges = [];

    rows.push([
      { v: `COBRANZA PROYECTADO VS REAL - ${(empresa && empresa.nombre) || ""}`, s: { font: { bold: true, sz: 14 } } },
    ]);
    merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: totalColumnas - 1 } });

    if (semanas.length > 0) {
      const primera = semanas[0];
      const ultima = semanas[semanas.length - 1];
      rows.push([
        {
          v: `PERIODO: ${primera.mes} ${primera.rango} — ${ultima.mes} ${ultima.rango}`,
          s: { font: { bold: true, sz: 11 } },
        },
      ]);
      merges.push({ s: { r: 1, c: 0 }, e: { r: 1, c: totalColumnas - 1 } });
    } else {
      rows.push([]);
    }

    const filaMesIndex = rows.length;
    const filaMes = [{ v: "", s: blankStyle }, { v: "", s: blankStyle }];
    let colActual = 2;
    let indiceSegmentoMes = 0;
    let i = 0;
    while (i < semanas.length) {
      const mes = semanas[i].mes;
      let j = i;
      while (j < semanas.length && semanas[j].mes === mes) j++;
      const estilo = mesStyle(MES_COLORS[indiceSegmentoMes % MES_COLORS.length]);
      const columnasDelMes = (j - i) * 2;
      filaMes.push({ v: mes, s: estilo });
      for (let k = 1; k < columnasDelMes; k++) filaMes.push({ v: "", s: estilo });
      if (columnasDelMes > 1) {
        merges.push({ s: { r: filaMesIndex, c: colActual }, e: { r: filaMesIndex, c: colActual + columnasDelMes - 1 } });
      }
      colActual += columnasDelMes;
      indiceSegmentoMes++;
      i = j;
    }
    filaMes.push(...blancos(meses.length * 4, blankStyle));
    rows.push(filaMes);

    const filaSemanaIndex = rows.length;
    const filaSemana = [{ v: "", s: blankStyle }, { v: "", s: blankStyle }];
    semanas.forEach((s, idx) => {
      filaSemana.push({ v: s.label, s: semanaStyle });
      filaSemana.push({ v: "", s: semanaStyle });
      merges.push({ s: { r: filaSemanaIndex, c: 2 + idx * 2 }, e: { r: filaSemanaIndex, c: 3 + idx * 2 } });
    });
    [
      ["MAQUINARIA", colMaquinaria],
      ["MATERIALES", colMateriales],
    ].forEach(([titulo, col]) => {
      meses.forEach((_, idx) => {
        filaSemana.push({ v: idx === 0 ? titulo : "", s: semanaStyle }, { v: "", s: semanaStyle });
      });
      if (meses.length > 0) {
        merges.push({ s: { r: filaSemanaIndex, c: col }, e: { r: filaSemanaIndex, c: col + meses.length * 2 - 1 } });
      }
    });
    rows.push(filaSemana);

    const filaRangoIndex = rows.length;
    const filaRango = [{ v: "", s: blankStyle }, { v: "", s: blankStyle }];
    semanas.forEach((s, idx) => {
      filaRango.push({ v: s.rango, s: rangoStyle });
      filaRango.push({ v: "", s: rangoStyle });
      merges.push({ s: { r: filaRangoIndex, c: 2 + idx * 2 }, e: { r: filaRangoIndex, c: 3 + idx * 2 } });
    });
    [colMaquinaria, colMateriales].forEach((col) => {
      meses.forEach((mes, idx) => {
        filaRango.push({ v: mes.label, s: semanaStyle }, { v: "", s: semanaStyle });
        merges.push({ s: { r: filaRangoIndex, c: col + idx * 2 }, e: { r: filaRangoIndex, c: col + idx * 2 + 1 } });
      });
    });
    rows.push(filaRango);

    const subHeaderPorMes = () =>
      meses.flatMap(() => [
        { v: "PROYECTADO", s: subHeaderStyle },
        { v: "REAL", s: subHeaderStyle },
      ]);
    const filaSubHeader = [
      { v: "", s: blankStyle },
      { v: "", s: blankStyle },
      ...semanas.flatMap(() => [
        { v: "PROYECTADO", s: subHeaderStyle },
        { v: "REAL", s: subHeaderStyle },
      ]),
      ...subHeaderPorMes(),
      ...subHeaderPorMes(),
    ];
    rows.push(filaSubHeader);

    const headerRow = [
      { v: "CLIENTE / PROYECTO", s: headerStyle },
      { v: "FACTURA", s: headerStyle },
      ...semanas.flatMap(() => [
        { v: "", s: headerStyle },
        { v: "", s: headerStyle },
      ]),
      ...blancos(meses.length * 4, headerStyle),
    ];
    rows.push(headerRow);

    grupos.forEach((grupo) => {
      const filaGrupo = [{ v: `${grupo.cliente} - ${grupo.proyecto}`, s: groupStyle }];
      for (let i = 1; i < totalColumnas; i++) {
        filaGrupo.push({ v: "", s: groupStyle });
      }
      rows.push(filaGrupo);

      (grupo.facturas || []).forEach((factura) => {
        rows.push([
          { v: "", s: plainBorder },
          { v: factura.folio || "", s: plainBorder },
          ...semanas.flatMap((s) => [
            celdaMoneda((factura.proyectado && factura.proyectado[s.key]) || 0, moneyStyle),
            celdaMoneda((factura.real && factura.real[s.key]) || 0, moneyStyle),
          ]),
          ...celdasPorMes(factura.maquinariaProyectadoPorMes, factura.maquinariaRealPorMes, moneyStyle),
          ...celdasPorMes(factura.materialesProyectadoPorMes, factura.materialesRealPorMes, moneyStyle),
        ]);
      });
    });

    if (grupos.length > 0) {
      rows.push([
        { v: "TOTALES GENERALES", s: totalStyle },
        { v: "", s: totalStyle },
        ...semanas.flatMap((s) => [
          celdaMoneda(totalesGeneralesProyectadoPorSemana[s.key] || 0, totalStyle),
          celdaMoneda(totalesGeneralesRealPorSemana[s.key] || 0, totalStyle),
        ]),
        ...celdasPorMes(generalesPorMes.maquinariaProyectadoPorMes, generalesPorMes.maquinariaRealPorMes, totalStyle),
        ...celdasPorMes(generalesPorMes.materialesProyectadoPorMes, generalesPorMes.materialesRealPorMes, totalStyle),
      ]);
    }

    const worksheet = XLSXStyle.utils.aoa_to_sheet(rows);
    worksheet["!merges"] = merges;
    worksheet["!cols"] = [
      { wch: 32 },
      { wch: 14 },
      ...semanas.flatMap(() => [{ wch: 14 }, { wch: 14 }]),
      ...Array.from({ length: meses.length * 4 }, () => ({ wch: 14 })),
    ];
    const workbook = XLSXStyle.utils.book_new();
    XLSXStyle.utils.book_append_sheet(workbook, worksheet, "Proyectado vs Real");
    XLSXStyle.writeFile(
      workbook,
      `Cobranza_Proyectado_vs_Real_${moment().locale("es").format("DD-MM-YYYY")}.xlsx`
    );
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    const { semanas, meses } = this.state;
    const totalColumnasHoja = 2 + semanas.length * 2 + meses.length * 4;

    const columnasFijas = [
      {
        title: "Cliente / Proyecto",
        dataIndex: "etiqueta",
        key: "etiqueta",
        width: 220,
        fixed: "left",
        ellipsis: true,
        onCell: (record) => ({
          colSpan: record.isHeader ? totalColumnasHoja : 1,
        }),
        render: (value, record) => {
          if (record.isGranTotal) return "TOTALES GENERALES";
          return value;
        },
      },
      {
        title: "Factura",
        dataIndex: "folio",
        key: "folio",
        width: 120,
        fixed: "left",
        ellipsis: true,
        onCell: (record) => ({
          colSpan: record.isHeader ? 0 : 1,
        }),
      },
    ];

    const columnasSemanas = semanas.map((semana) => ({
      title: () => (
        <div style={{ textAlign: "center" }}>
          <div>{semana.label}</div>
          <div style={{ fontSize: 11, fontWeight: 400 }}>{semana.rango}</div>
        </div>
      ),
      key: semana.key,
      align: "center",
      children: [
        {
          title: "Proyectado",
          dataIndex: ["proyectado", semana.key],
          key: `${semana.key}-proyectado`,
          align: "right",
          width: 110,
          onCell: (record) => ({
            colSpan: record.isHeader ? 0 : 1,
          }),
          render: (value, record) => (record.isHeader ? "" : dineroDisabledMask(value || 0)),
        },
        {
          title: "Real",
          dataIndex: ["real", semana.key],
          key: `${semana.key}-real`,
          align: "right",
          width: 110,
          onCell: (record) => ({
            colSpan: record.isHeader ? 0 : 1,
          }),
          render: (value, record) => (record.isHeader ? "" : dineroDisabledMask(value || 0)),
        },
      ],
    }));

    // Maquinaria y materiales se desglosan por mes, y cada mes en proyectado y real.
    const columnaSeparadaPorMes = (titulo, campo) => ({
      title: () => <div style={{ textAlign: "center" }}>{titulo}</div>,
      key: campo,
      align: "center",
      children: meses.map((mes) => ({
        title: () => <div style={{ textAlign: "center" }}>{mes.label}</div>,
        key: `${campo}-${mes.key}`,
        align: "center",
        children: [
          {
            title: "Proyectado",
            dataIndex: [`${campo}ProyectadoPorMes`, mes.key],
            key: `${campo}-${mes.key}-proyectado`,
            align: "right",
            width: 110,
            onCell: (record) => ({
              colSpan: record.isHeader ? 0 : 1,
            }),
            render: (value, record) => (record.isHeader ? "" : dineroDisabledMask(value || 0)),
          },
          {
            title: "Real",
            dataIndex: [`${campo}RealPorMes`, mes.key],
            key: `${campo}-${mes.key}-real`,
            align: "right",
            width: 110,
            onCell: (record) => ({
              colSpan: record.isHeader ? 0 : 1,
            }),
            render: (value, record) => (record.isHeader ? "" : dineroDisabledMask(value || 0)),
          },
        ],
      })),
    });

    const columnaMaquinaria = columnaSeparadaPorMes("Maquinaria", "maquinaria");
    const columnaMateriales = columnaSeparadaPorMes("Materiales", "materiales");

    const columns = [...columnasFijas, ...columnasSemanas, columnaMaquinaria, columnaMateriales];

    return (
      <>
        <Form
          ref={this.formRef}
          name="reporteCobranzaProyectadoVsReal"
          onFinish={this.consultarReporte.bind(this)}
          onFinishFailed={this.onFinishFailed}
          initialValues={{
            periodo: [moment().subtract(1, "month"), moment()],
            diaInicioSemana: leerDiaInicioSemanaGuardado(),
            separarMaquinaria: leerSepararMaquinariaGuardado(),
            separarMateriales: leerSepararMaterialesGuardado(),
          }}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Reporte Cobranza Proyectado vs Real"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarExcel()}
                      icon={<FileExcelOutlined />}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Descargar Excel
                    </ButtonItem>
                  )}
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Consultar
                  </ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Tabs
                style={{ margin: 0 }}
                tabBarExtraContent={{
                  left: (
                    <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>Filtros:</h1>
                  ),
                }}
              >
                <TabPane tabKey="1" key="1" forceRender tab="Periodo">
                  <FormItem name="periodo" required noStyle>
                    <RangePickerItem />
                  </FormItem>
                </TabPane>
                <TabPane tabKey="2" key="2" forceRender tab="Clientes">
                  <FormItem name="clientes" noStyle margin>
                    <SelectItem width="90%" mode="multiple" placeholder="Clientes">
                      {this.state.objetoClientes}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="3" key="3" forceRender tab="Proyectos">
                  <FormItem name="proyectos" noStyle margin>
                    <SelectItem width="90%" mode="multiple" placeholder="Proyectos">
                      {this.state.objetoProyectos}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="4" key="4" forceRender tab="Semana">
                  <FormItem name="diaInicioSemana" noStyle margin>
                    <SelectItem width="90%" placeholder="Día de inicio de semana">
                      {DIAS_SEMANA.map((dia) => (
                        <Option value={dia.value} key={dia.value}>
                          {dia.label}
                        </Option>
                      ))}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="5" key="5" forceRender tab="Separar">
                  <FormItem
                    label="Separar Renta de Maquinaria"
                    name="separarMaquinaria"
                    valuePropName="checked"
                    margin
                  >
                    <SwitchItem />
                  </FormItem>
                  <FormItem
                    label="Separar Suministro de Materiales"
                    name="separarMateriales"
                    valuePropName="checked"
                    margin
                  >
                    <SwitchItem />
                  </FormItem>
                </TabPane>
              </Tabs>
            </div>

            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingBottom: 35,
                marginTop: 10,
                marginBottom: 10,
                height: 420,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <h1 style={{ fontSize: 18, margin: 0, marginBottom: 10 }}>
                Proyectado vs Real por semana
              </h1>
              <ResponsiveLine
                data={this.state.dataGrafico}
                margin={{ top: 15, right: 20, bottom: 70, left: 100 }}
                enableSlices="x"
                useMesh={true}
                yFormat={(e) => dineroDisabledMask(Math.abs(e))}
                xScale={{ type: "point" }}
                yScale={{
                  type: "linear",
                  min: 0,
                  max: "auto",
                  stacked: false,
                  reverse: false,
                }}
                curve="monotoneX"
                lineWidth={2}
                pointSize={5}
                pointBorderWidth={1}
                pointColor={{ theme: "background" }}
                pointBorderColor={{ from: "serieColor" }}
                colors={["#1890FF", "#52C41A"]}
                colorBy="index"
                axisTop={null}
                axisRight={null}
                axisBottom={{
                  tickSize: 5,
                  tickPadding: 8,
                  tickRotation: 45,
                  tickValues: (this.state.dataGrafico?.[0]?.data || [])
                    .map((d) => d.x)
                    .filter((_, i) => i % 2 === 0),
                }}
                axisLeft={{
                  tickSize: 5,
                  tickPadding: 8,
                  format: (v) => dineroDisabledMask(Math.abs(v)),
                }}
                enableGridX={false}
                legends={[
                  {
                    anchor: "top-right",
                    direction: "column",
                    translateX: 0,
                    translateY: 0,
                    itemWidth: 130,
                    itemHeight: 18,
                    symbolSize: 10,
                    symbolShape: "circle",
                    itemOpacity: 0.85,
                    effects: [{ on: "hover", style: { itemOpacity: 1 } }],
                  },
                ]}
              />
            </div>

            <div
              style={{
                backgroundColor: "white",
                padding: 15,
                marginBottom: 10,
                height: "75px",
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Row gutter={16}>
                <Col span={8} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Total Proyectado</p>
                  <h1 style={{ fontSize: 15 }}>
                    {dineroDisabledMask(this.state.totalProyectado)}
                  </h1>
                </Col>
                <Col span={8} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Total Real</p>
                  <h1 style={{ fontSize: 15 }}>
                    {dineroDisabledMask(this.state.totalReal)}
                  </h1>
                </Col>
                <Col span={8} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>% Cumplimiento</p>
                  <h1 style={{ fontSize: 15 }}>
                    {this.state.totalProyectado > 0
                      ? `${Math.round((this.state.totalReal / this.state.totalProyectado) * 100)}%`
                      : "—"}
                  </h1>
                </Col>
              </Row>
            </div>

            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <TableItem
                rowKey="key"
                columns={columns}
                dataSource={this.state.filas}
                size="small"
                pagination={false}
                scroll={{ x: "max-content" }}
                rowClassName={(record) =>
                  record.isHeader
                    ? "fila-grupo-cobranza"
                    : record.isGranTotal
                    ? "fila-total-cobranza"
                    : ""
                }
              />
            </div>
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ReporteCobranzaProyectadoVsReal);
